import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Button } from "primereact/button";
import "primeicons/primeicons.css";
import EzTable from "../../common/EzTable";
import EzNotFound from "../../common/EzNotFound";

const getIconPath = (imgPathDelta = "/no-record.png") =>
  process.env.PUBLIC_URL + imgPathDelta;
const CustomerComponent = ({
  tableData,
  paginationInfo,
  screenPermissions,
  isPageLevelError,
  fetchCustomers,
  createCustomerCompany,
  updateCustomer,
  isLoading,
}) => {
  const [areFiltersVisible, toggleFilterState] = useState(false);
  const renderPageHeaderSection = () => {
    return (
      <div className="make-relative">
        <div
          className=""
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <div className="ml-3">
              <h4>Customer</h4>
            </div>
            <Button
              label={areFiltersVisible ? "Advanced Filter" : "Advanced Filter"}
              icon={areFiltersVisible ? "pi pi-filter-slash" : "pi pi-filter"}
              className={`p-button-text p-button-secondary`}
              onClick={() => {
                toggleFilterState(!areFiltersVisible);
              }}
            />
          </div>
          <div>
            {screenPermissions?.create && (
              <Button
                label={"Add Customer Company"}
                className={`p-button-raised`}
                onClick={createCustomerCompany}
              />
            )}
          </div>
        </div>
      </div>
    );
  };
  const filters = {
    global: { value: null },
    name: { filterKey: "name", value: null },
    phone: { filterKey: "phone", value: null },
    tax_no: { filterKey: "tax_no", value: null },
    crm_id: { filterKey: "crm_id", value: null },
    rate: { filterKey: "rate", value: null },
    order_cnt: { filterKey: "order_cnt", value: null },
    invoice_cnt: { filterKey: "invoice_cnt", value: null },
  };

  const shouldRenderFullPageError = () => isPageLevelError;
  const shouldCustomerRecords = () => tableData?.columns?.length > 0;
  const shouldRenderNotFoundView = () =>
    !shouldCustomerRecords() && !shouldRenderFullPageError();

  const tableProps = {
    areFiltersVisible,
    columns: tableData?.columns,
    paginationInfo,
    screenPermissions,
    value: tableData?.rows,
    emptyMessage: "No Customer found.",
    filters,
    sortField: null,
    loading: isLoading,
    showMoreActions: false,
    loadLazyData: fetchCustomers,
    createCustomerCompany,
    onEditRecord: updateCustomer,
    showViewButton: false,
  };

  return (
    <>
      <div className="paddingbox">
        <div className="containerbox">
          {renderPageHeaderSection()}
          <div className="mTop15">
            {shouldRenderFullPageError() && (
              <EzNotFound
                messageStyle={{ marginLeft: "-70px" }}
                bgImgUrl={getIconPath("something-broke.png")}
                message={"Oops! Something broke, we are working on a fix."}
              />
            )}
            {shouldCustomerRecords() && (
              <Row>
                <Col md={12}>
                  <EzTable {...tableProps} />
                </Col>
              </Row>
            )}
            {shouldRenderNotFoundView() && (
              <EzNotFound
                bgImgUrl={getIconPath()}
                message={"No Comapny records to show"}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerComponent;
